module.exports = __webpack_public_path__ + "img/blob8.00ef47b0.svg";